/**
 * Copyright (c) 2017-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './../src/api'
import './../src/objects/ad-video';
import './../src/objects/alm-ad-account-info';
import './../src/objects/alm-end-advertiser-info';
import './../src/objects/alm-event';
import './../src/objects/alm-guidance';
import './../src/objects/alm-guidance-metrics';
import './../src/objects/am-oneshop-settings';
import './../src/objects/an-blocked-bi-category';
import './../src/objects/ar-effect';
import './../src/objects/ad';
import './../src/objects/ad-account';
import './../src/objects/ad-account-aaa-compatible-ad-objects';
import './../src/objects/ad-account-aaa-similar-campaigns';
import './../src/objects/ad-account-asl-schedule';
import './../src/objects/ad-account-ad-limits-insights';
import './../src/objects/ad-account-ad-rules-count-by-type';
import './../src/objects/ad-account-ad-rules-history';
import './../src/objects/ad-account-ad-volume';
import './../src/objects/ad-account-ads-recommended-audios';
import './../src/objects/ad-account-all-payment-methods';
import './../src/objects/ad-account-app-setup-requirements';
import './../src/objects/ad-account-bank-info-list';
import './../src/objects/ad-account-billing-date-preference';
import './../src/objects/ad-account-business-constraints';
import './../src/objects/ad-account-campaign-attribution-option-info';
import './../src/objects/ad-account-creation-request';
import './../src/objects/ad-account-custom-audience-limits';
import './../src/objects/ad-account-default-destination';
import './../src/objects/ad-account-default-objective';
import './../src/objects/ad-account-delivery-estimate';
import './../src/objects/ad-account-dsa-recommendations';
import './../src/objects/ad-account-ios-fourteen-campaign-limits';
import './../src/objects/ad-account-live-video-advertiser';
import './../src/objects/ad-account-matched-search-applications-edge-data';
import './../src/objects/ad-account-max-bid';
import './../src/objects/ad-account-optimization-goals-aemv2-eligibility';
import './../src/objects/ad-account-payment-details';
import './../src/objects/ad-account-payment-options';
import './../src/objects/ad-account-prepay-details';
import './../src/objects/ad-account-promotable-objects';
import './../src/objects/ad-account-promotion-progress-bar';
import './../src/objects/ad-account-reach-estimate';
import './../src/objects/ad-account-recommendations';
import './../src/objects/ad-account-recommended-camapaign-budget';
import './../src/objects/ad-account-related-ico-study';
import './../src/objects/ad-account-smart-suggested-ads';
import './../src/objects/ad-account-spend-limit';
import './../src/objects/ad-account-subscribed-apps';
import './../src/objects/ad-account-subsidy-amount-details';
import './../src/objects/ad-account-suggested-tag';
import './../src/objects/ad-account-targeting-unified';
import './../src/objects/ad-account-tracking-data';
import './../src/objects/ad-account-url-for-asset-extraction';
import './../src/objects/ad-account-user';
import './../src/objects/ad-account-user-permissions';
import './../src/objects/ad-account-user-settings';
import './../src/objects/ad-account-youth-ads-advertiser';
import './../src/objects/ad-activity';
import './../src/objects/ad-asset-body';
import './../src/objects/ad-asset-call-to-action-type';
import './../src/objects/ad-asset-customization-rule-customization-spec';
import './../src/objects/ad-asset-description';
import './../src/objects/ad-asset-feed-additional-data';
import './../src/objects/ad-asset-feed-additional-data-page-nudge-message';
import './../src/objects/ad-asset-feed-spec';
import './../src/objects/ad-asset-feed-spec-asset-customization-rule';
import './../src/objects/ad-asset-feed-spec-asset-label';
import './../src/objects/ad-asset-feed-spec-body';
import './../src/objects/ad-asset-feed-spec-call-to-action';
import './../src/objects/ad-asset-feed-spec-caption';
import './../src/objects/ad-asset-feed-spec-carousel';
import './../src/objects/ad-asset-feed-spec-carousel-child-attachment';
import './../src/objects/ad-asset-feed-spec-description';
import './../src/objects/ad-asset-feed-spec-events';
import './../src/objects/ad-asset-feed-spec-group-rule';
import './../src/objects/ad-asset-feed-spec-image';
import './../src/objects/ad-asset-feed-spec-link-url';
import './../src/objects/ad-asset-feed-spec-title';
import './../src/objects/ad-asset-feed-spec-video';
import './../src/objects/ad-asset-image';
import './../src/objects/ad-asset-link-url';
import './../src/objects/ad-asset-message-extensions';
import './../src/objects/ad-asset-onsite-destinations';
import './../src/objects/ad-asset-target-rule-targeting';
import './../src/objects/ad-asset-title';
import './../src/objects/ad-asset-video';
import './../src/objects/ad-async-request';
import './../src/objects/ad-async-request-set';
import './../src/objects/ad-async-request-set-notification-result';
import './../src/objects/ad-bid-adjustments';
import './../src/objects/ad-campaign-bid-constraint';
import './../src/objects/ad-campaign-conversion-value-expression-spec';
import './../src/objects/ad-campaign-delivery-estimate';
import './../src/objects/ad-campaign-delivery-stats';
import './../src/objects/ad-campaign-delivery-stats-unsupported-reasons';
import './../src/objects/ad-campaign-frequency-control-specs';
import './../src/objects/ad-campaign-group-incremental-conversion-optimization-config';
import './../src/objects/ad-campaign-group-metrics-metadata';
import './../src/objects/ad-campaign-group-stats';
import './../src/objects/ad-campaign-group-structure-tree';
import './../src/objects/ad-campaign-issues-info';
import './../src/objects/ad-campaign-learning-stage-info';
import './../src/objects/ad-campaign-metrics-metadata';
import './../src/objects/ad-campaign-multi-ads';
import './../src/objects/ad-campaign-optimization-event';
import './../src/objects/ad-campaign-paced-bid-info';
import './../src/objects/ad-campaign-stats';
import './../src/objects/ad-column-sizes';
import './../src/objects/ad-contract';
import './../src/objects/ad-conversion-values';
import './../src/objects/ad-conversions';
import './../src/objects/ad-creation-package-config';
import './../src/objects/ad-creative';
import './../src/objects/ad-creative-ad-disclaimer';
import './../src/objects/ad-creative-asset-groups-spec';
import './../src/objects/ad-creative-branded-content-ads';
import './../src/objects/ad-creative-branded-content-ads-partners';
import './../src/objects/ad-creative-collection-thumbnail-info';
import './../src/objects/ad-creative-contextual-multi-ads';
import './../src/objects/ad-creative-degrees-of-freedom-spec';
import './../src/objects/ad-creative-destination-spec';
import './../src/objects/ad-creative-facebook-branded-content';
import './../src/objects/ad-creative-feature-action-metadata';
import './../src/objects/ad-creative-feature-customizations';
import './../src/objects/ad-creative-feature-details';
import './../src/objects/ad-creative-features-spec';
import './../src/objects/ad-creative-generative-asset-spec';
import './../src/objects/ad-creative-house-shops-ads-seller-content';
import './../src/objects/ad-creative-image-data-media-elements';
import './../src/objects/ad-creative-insights';
import './../src/objects/ad-creative-instagram-branded-content';
import './../src/objects/ad-creative-interactive-components-spec';
import './../src/objects/ad-creative-link-data';
import './../src/objects/ad-creative-link-data-app-link-spec';
import './../src/objects/ad-creative-link-data-call-to-action';
import './../src/objects/ad-creative-link-data-call-to-action-value';
import './../src/objects/ad-creative-link-data-child-attachment';
import './../src/objects/ad-creative-link-data-custom-overlay-spec';
import './../src/objects/ad-creative-link-data-image-layer-spec';
import './../src/objects/ad-creative-link-data-image-overlay-spec';
import './../src/objects/ad-creative-link-data-moment';
import './../src/objects/ad-creative-link-data-sponsorship-info-spec';
import './../src/objects/ad-creative-link-data-template-video-spec';
import './../src/objects/ad-creative-marketing-message-structured-spec';
import './../src/objects/ad-creative-object-story-spec';
import './../src/objects/ad-creative-omnichannel-link-spec';
import './../src/objects/ad-creative-photo-data';
import './../src/objects/ad-creative-photo-data-media-elements';
import './../src/objects/ad-creative-place-data';
import './../src/objects/ad-creative-platform-customization';
import './../src/objects/ad-creative-portrait-customizations';
import './../src/objects/ad-creative-post-click-configuration';
import './../src/objects/ad-creative-product-data';
import './../src/objects/ad-creative-promotion-metadata-spec';
import './../src/objects/ad-creative-recommender-settings';
import './../src/objects/ad-creative-regional-regulation-disclaimer';
import './../src/objects/ad-creative-reward-info';
import './../src/objects/ad-creative-shop-spec';
import './../src/objects/ad-creative-site-links-spec';
import './../src/objects/ad-creative-sourcing-spec';
import './../src/objects/ad-creative-static-fallback-spec';
import './../src/objects/ad-creative-template-url-spec';
import './../src/objects/ad-creative-text-data';
import './../src/objects/ad-creative-video-data';
import './../src/objects/ad-creative-video-data-custom-overlay-spec';
import './../src/objects/ad-creative-video-data-media-elements';
import './../src/objects/ad-creative-whats-app-channel-spec';
import './../src/objects/ad-custom-derived-metrics';
import './../src/objects/ad-customization-rule-spec';
import './../src/objects/ad-default-values';
import './../src/objects/ad-draft';
import './../src/objects/ad-dynamic-creative';
import './../src/objects/ad-entity-target-spend';
import './../src/objects/ad-export-preset';
import './../src/objects/ad-image';
import './../src/objects/ad-keyword-stats';
import './../src/objects/ad-keywords';
import './../src/objects/ad-kpi-shift';
import './../src/objects/ad-label';
import './../src/objects/ad-light-adgroup';
import './../src/objects/ad-light-campaign';
import './../src/objects/ad-light-campaign-group';
import './../src/objects/ad-limit-setting';
import './../src/objects/ad-limits-enforcement-data';
import './../src/objects/ad-monetization-property';
import './../src/objects/ad-network-analytics-async-query-export';
import './../src/objects/ad-network-analytics-async-query-result';
import './../src/objects/ad-network-analytics-sync-query-result';
import './../src/objects/ad-place-page-set';
import './../src/objects/ad-place-page-set-metadata';
import './../src/objects/ad-placement';
import './../src/objects/ad-preview';
import './../src/objects/ad-promoted-object';
import './../src/objects/ad-proposal';
import './../src/objects/ad-recommendation';
import './../src/objects/ad-recommendation-data';
import './../src/objects/ad-report-run';
import './../src/objects/ad-rule';
import './../src/objects/ad-rule-evaluation-spec';
import './../src/objects/ad-rule-execution-options';
import './../src/objects/ad-rule-execution-spec';
import './../src/objects/ad-rule-filters';
import './../src/objects/ad-rule-history';
import './../src/objects/ad-rule-history-result';
import './../src/objects/ad-rule-history-result-action';
import './../src/objects/ad-rule-schedule';
import './../src/objects/ad-rule-schedule-spec';
import './../src/objects/ad-rule-trigger';
import './../src/objects/ad-saved-keywords';
import './../src/objects/ad-saved-location';
import './../src/objects/ad-saved-report';
import './../src/objects/ad-set';
import './../src/objects/ad-study';
import './../src/objects/ad-study-cell';
import './../src/objects/ad-study-objective';
import './../src/objects/ad-study-objective-id';
import './../src/objects/ad-study-objective-offsite-datasets';
import './../src/objects/ad-topline';
import './../src/objects/ad-topline-detail';
import './../src/objects/ad-video';
import './../src/objects/ad-volume';
import './../src/objects/adgroup-facebook-feedback';
import './../src/objects/adgroup-issues-info';
import './../src/objects/adgroup-metadata';
import './../src/objects/adgroup-placement-specific-review-feedback';
import './../src/objects/adgroup-review-feedback';
import './../src/objects/adjacent-content-delivery-report';
import './../src/objects/ads-action-stats';
import './../src/objects/ads-anomaly-detection';
import './../src/objects/ads-conversion-goal';
import './../src/objects/ads-creation-saved-state';
import './../src/objects/ads-custom-pivots-preview';
import './../src/objects/ads-data-partner';
import './../src/objects/ads-dataset';
import './../src/objects/ads-guidance-qe-exposure';
import './../src/objects/ads-histogram-stats';
import './../src/objects/ads-image-crops';
import './../src/objects/ads-insights';
import './../src/objects/ads-naming-template';
import './../src/objects/ads-optimal-delivery-growth-opportunity';
import './../src/objects/ads-payment-cycle';
import './../src/objects/ads-pivot-rules';
import './../src/objects/ads-pixel';
import './../src/objects/ads-pixel-capi-setup-quality';
import './../src/objects/ads-pixel-capability-override';
import './../src/objects/ads-pixel-delivery-recommendations';
import './../src/objects/ads-pixel-domain-control-rule';
import './../src/objects/ads-pixel-domain-last-fired-time';
import './../src/objects/ads-pixel-event-last-fired-time';
import './../src/objects/ads-pixel-event-prediction';
import './../src/objects/ads-pixel-event-suggestion-rule';
import './../src/objects/ads-pixel-item-price';
import './../src/objects/ads-pixel-microdata-stats';
import './../src/objects/ads-pixel-raw-fires-result';
import './../src/objects/ads-pixel-real-time-event-log-result';
import './../src/objects/ads-pixel-recent-events-result';
import './../src/objects/ads-pixel-signals-iwl-feedback-nux';
import './../src/objects/ads-pixel-signals-iwl-nux';
import './../src/objects/ads-pixel-stats';
import './../src/objects/ads-pixel-stats-result';
import './../src/objects/ads-quick-views';
import './../src/objects/ads-report-builder';
import './../src/objects/ads-report-builder-export-core';
import './../src/objects/ads-report-builder-mmm-report';
import './../src/objects/ads-report-builder-mmm-report-scheduler';
import './../src/objects/ads-report-builder-saved-report';
import './../src/objects/ads-segments';
import './../src/objects/ads-signal-diagnostic-issue';
import './../src/objects/ads-start-your-day-widget';
import './../src/objects/ads-tabular';
import './../src/objects/ads-targeting-insights';
import './../src/objects/ads-text-suggestions';
import './../src/objects/ads-user-settings';
import './../src/objects/ads-value-adjustment-rule';
import './../src/objects/ads-value-adjustment-rule-collection';
import './../src/objects/adv-a-instance';
import './../src/objects/advertiser-verification-status';
import './../src/objects/age-range';
import './../src/objects/agency-client-declaration';
import './../src/objects/album';
import './../src/objects/analytics-cohort-query-result';
import './../src/objects/analytics-config';
import './../src/objects/analytics-entity-user-config';
import './../src/objects/analytics-funnel-query-result';
import './../src/objects/analytics-platform-metrics-config';
import './../src/objects/analytics-query-result';
import './../src/objects/analytics-segment';
import './../src/objects/analytics-user-config';
import './../src/objects/android-app-link';
import './../src/objects/app-event-config';
import './../src/objects/app-links';
import './../src/objects/app-optimized-custom-events';
import './../src/objects/app-publisher';
import './../src/objects/app-request';
import './../src/objects/app-request-former-recipient';
import './../src/objects/application';
import './../src/objects/ar-ads-data-container';
import './../src/objects/assigned-user';
import './../src/objects/async-request';
import './../src/objects/async-session';
import './../src/objects/attribution-spec';
import './../src/objects/audience-funnel';
import './../src/objects/audience-overlap';
import './../src/objects/audience-permission';
import './../src/objects/audience-permission-for-actions';
import './../src/objects/audience-sharing-account-valid';
import './../src/objects/audience-sharing-recipient-accounts';
import './../src/objects/audio-asset';
import './../src/objects/audio-copyright';
import './../src/objects/audio-isrc';
import './../src/objects/audio-release';
import './../src/objects/audio-visual-reference-match';
import './../src/objects/auth-link';
import './../src/objects/automotive-model';
import './../src/objects/avatar';
import './../src/objects/avatar-profile-picture';
import './../src/objects/bapi-domain';
import './../src/objects/bcp-campaign';
import './../src/objects/bespoke-partner-guidance-laser';
import './../src/objects/bid-schedule';
import './../src/objects/biz-inbox-offsite-email-account';
import './../src/objects/blind-pig';
import './../src/objects/blocked-user-info';
import './../src/objects/brand-request';
import './../src/objects/brand-safety-block-list-usage';
import './../src/objects/brand-safety-campaign-config';
import './../src/objects/brand-safety-downloadable';
import './../src/objects/branded-content-ad-error';
import './../src/objects/branded-content-eligible-sponsor-i-ds';
import './../src/objects/branded-content-shadow-ig-media-id';
import './../src/objects/branded-content-shadow-ig-user-id';
import './../src/objects/broad-targeting-categories';
import './../src/objects/business';
import './../src/objects/business-ad-account-request';
import './../src/objects/business-ads-reporting-report-specs';
import './../src/objects/business-advertisable-applications-result';
import './../src/objects/business-agreement';
import './../src/objects/business-application-request';
import './../src/objects/business-asset-group';
import './../src/objects/business-asset-sharing-agreement';
import './../src/objects/business-creative';
import './../src/objects/business-creative-folder';
import './../src/objects/business-creative-insights';
import './../src/objects/business-franchise-config';
import './../src/objects/business-image';
import './../src/objects/business-image-t-business-folder-path-item';
import './../src/objects/business-managed-partner-eligibility';
import './../src/objects/business-media-ad-placement-validation-result';
import './../src/objects/business-object';
import './../src/objects/business-object-transfer-ownership-agreement';
import './../src/objects/business-owned-object-on-behalf-of-request';
import './../src/objects/business-page-request';
import './../src/objects/business-partner-premium-options';
import './../src/objects/business-product-catalog-tos';
import './../src/objects/business-project';
import './../src/objects/business-request';
import './../src/objects/business-role-request';
import './../src/objects/business-setting-logs-data';
import './../src/objects/business-tag';
import './../src/objects/business-traffic-analysis-report';
import './../src/objects/business-user';
import './../src/objects/business-video';
import './../src/objects/business-video-t-business-folder-path-item';
import './../src/objects/cass-setup-offline-event-set-progress';
import './../src/objects/cpas-ad-creation-template';
import './../src/objects/cpas-advertiser-partnership-recommendation';
import './../src/objects/cpas-business-setup-config';
import './../src/objects/cpas-collaboration-request';
import './../src/objects/cpas-lsb-image-bank';
import './../src/objects/cpas-merchant-config';
import './../src/objects/cpas-parent-catalog-settings';
import './../src/objects/cpas-setup';
import './../src/objects/cpas-setup-page-structure-progress';
import './../src/objects/crm-address';
import './../src/objects/ctwa-whats-app-numbers-info';
import './../src/objects/ctx-optimization-eligibility';
import './../src/objects/ctx-partner-app-welcome-message-flow';
import './../src/objects/calibrator-existing-rule';
import './../src/objects/call-ads-phone-data';
import './../src/objects/campaign';
import './../src/objects/campaign-actions-data';
import './../src/objects/campaign-group-brand-configuration';
import './../src/objects/campaign-group-collaborative-ads-partner-info';
import './../src/objects/canvas';
import './../src/objects/canvas-ad-settings';
import './../src/objects/canvas-body-element';
import './../src/objects/canvas-collection-thumbnail';
import './../src/objects/canvas-dynamic-setting';
import './../src/objects/canvas-preview';
import './../src/objects/canvas-template';
import './../src/objects/catalog-based-targeting';
import './../src/objects/catalog-item-app-links';
import './../src/objects/catalog-item-channels-to-integrity-status';
import './../src/objects/catalog-item-override';
import './../src/objects/catalog-item-rejection-reasons';
import './../src/objects/catalog-item-validation-error-list';
import './../src/objects/catalog-smart-pixel-settings';
import './../src/objects/catalog-sub-vertical-list';
import './../src/objects/catalog-website-onboarding-settings';
import './../src/objects/catalog-website-settings';
import './../src/objects/chat-plugin';
import './../src/objects/check-batch-request-status';
import './../src/objects/child-event';
import './../src/objects/china-business-onboarding-vetting-request';
import './../src/objects/cloud-game';
import './../src/objects/cloudbridge-dataset-status';
import './../src/objects/collaborative-ads-partner-businesses';
import './../src/objects/collaborative-ads-partner-info-list-item';
import './../src/objects/collaborative-ads-share-settings';
import './../src/objects/column-suggestions';
import './../src/objects/comment';
import './../src/objects/commerce-merchant-settings';
import './../src/objects/commerce-merchant-settings-setup-status';
import './../src/objects/commerce-order';
import './../src/objects/commerce-order-transaction-detail';
import './../src/objects/commerce-payout';
import './../src/objects/commerce-settings';
import './../src/objects/connections-targeting';
import './../src/objects/contacts-messenger-sync-config';
import './../src/objects/content-block-list';
import './../src/objects/content-delivery-report';
import './../src/objects/content-publishing-limit-response';
import './../src/objects/contextual-bundling-spec';
import './../src/objects/conversion-action-query';
import './../src/objects/conversion-health-kpi';
import './../src/objects/copyright-attribution-insights';
import './../src/objects/copyright-audio-asset';
import './../src/objects/copyright-media-misuse';
import './../src/objects/copyright-reference-container';
import './../src/objects/cover-photo';
import './../src/objects/creative-asset-tag';
import './../src/objects/creative-history';
import './../src/objects/creator-asset-creative';
import './../src/objects/credit-card';
import './../src/objects/credit-partition-action-options';
import './../src/objects/currency';
import './../src/objects/currency-amount';
import './../src/objects/custom-audience';
import './../src/objects/custom-audience-ad-account';
import './../src/objects/custom-audience-capabilities';
import './../src/objects/custom-audience-data-source';
import './../src/objects/custom-audience-group';
import './../src/objects/custom-audience-salts';
import './../src/objects/custom-audience-session';
import './../src/objects/custom-audience-shared-account-campaign-info';
import './../src/objects/custom-audience-sharing-status';
import './../src/objects/custom-audience-status';
import './../src/objects/custom-audiences-tos';
import './../src/objects/custom-audienceshared-account-info';
import './../src/objects/custom-conversion';
import './../src/objects/custom-conversion-activities';
import './../src/objects/custom-conversion-stats-result';
import './../src/objects/custom-user-settings';
import './../src/objects/da-check';
import './../src/objects/dataset';
import './../src/objects/day-part';
import './../src/objects/delivery-check';
import './../src/objects/delivery-check-extra-info';
import './../src/objects/delivery-info';
import './../src/objects/delivery-status';
import './../src/objects/delivery-window';
import './../src/objects/destination';
import './../src/objects/direct-debit';
import './../src/objects/domain';
import './../src/objects/draft-post';
import './../src/objects/dynamic-ar-metadata';
import './../src/objects/dynamic-content-set';
import './../src/objects/dynamic-item-display-bundle';
import './../src/objects/dynamic-item-display-bundle-folder';
import './../src/objects/dynamic-post-child-attachment';
import './../src/objects/dynamic-price-config-by-date';
import './../src/objects/dynamic-video-metadata';
import './../src/objects/education-experience';
import './../src/objects/email-import';
import './../src/objects/end-study-criteria';
import './../src/objects/engagement';
import './../src/objects/ent-with-sponsor';
import './../src/objects/entity-at-text-range';
import './../src/objects/event';
import './../src/objects/event-external-ticket-info';
import './../src/objects/event-registration-setting';
import './../src/objects/event-source-group';
import './../src/objects/event-ticket-setting';
import './../src/objects/event-ticket-tier';
import './../src/objects/event-tour';
import './../src/objects/experience';
import './../src/objects/extended-credit';
import './../src/objects/extended-credit-allocation-config';
import './../src/objects/extended-credit-application';
import './../src/objects/extended-credit-email';
import './../src/objects/extended-credit-info';
import './../src/objects/extended-credit-invoice-group';
import './../src/objects/external-event-source';
import './../src/objects/external-event-source-cpas-events-debugging';
import './../src/objects/external-event-source-cpas-events-debugging-info';
import './../src/objects/external-merchant-settings';
import './../src/objects/fame-kumo';
import './../src/objects/fb-image-copyright-match';
import './../src/objects/fb-lite-to-nt-transitions';
import './../src/objects/fb-page-and-instagram-account';
import './../src/objects/fb-pay-button-login';
import './../src/objects/fantasy-game';
import './../src/objects/favorite-catalog';
import './../src/objects/finance-object';
import './../src/objects/flexible-targeting';
import './../src/objects/flight';
import './../src/objects/franchise-program';
import './../src/objects/franchise-program-member';
import './../src/objects/funding-source-details';
import './../src/objects/funding-source-details-coupon';
import './../src/objects/fundraiser-person-to-charity';
import './../src/objects/geo-gating-policy';
import './../src/objects/group';
import './../src/objects/has-lead-access';
import './../src/objects/high-demand-period';
import './../src/objects/high-demand-period-time-suggestion-weekly-segment';
import './../src/objects/home-listing';
import './../src/objects/hotel';
import './../src/objects/hotel-room';
import './../src/objects/hours';
import './../src/objects/id-name';
import './../src/objects/ig-access-token-for-ig-only-api';
import './../src/objects/igbc-ads-permission';
import './../src/objects/ig-boost-media-ad';
import './../src/objects/ig-comment';
import './../src/objects/ig-comment-from-user';
import './../src/objects/ig-media';
import './../src/objects/ig-media-boost-eligibility-info';
import './../src/objects/ig-media-for-ig-only-api';
import './../src/objects/ig-product-tagging-invalidation-error';
import './../src/objects/ig-refresh-access-token-for-ig-only-api';
import './../src/objects/ig-resumable-video-upload-status';
import './../src/objects/ig-shopping-product-appeal';
import './../src/objects/ig-shopping-review-status';
import './../src/objects/ig-shopping-review-status-onsite-eligibility';
import './../src/objects/ig-shopping-review-status-reason-with-help-message';
import './../src/objects/ig-upcoming-event';
import './../src/objects/ig-user';
import './../src/objects/ig-user-export-for-cam';
import './../src/objects/ig-user-for-ig-only-api';
import './../src/objects/ig-video-copyright-check-matches-information';
import './../src/objects/ig-video-copyright-check-status';
import './../src/objects/ip-object';
import './../src/objects/image-copyright';
import './../src/objects/image-copyright-dispute';
import './../src/objects/image-reference-match';
import './../src/objects/insights-result';
import './../src/objects/insights-value';
import './../src/objects/instagram-boostable-media-for-access-token';
import './../src/objects/instagram-carousel';
import './../src/objects/instagram-comment';
import './../src/objects/instagram-insights-result';
import './../src/objects/instagram-insights-value';
import './../src/objects/instagram-media';
import './../src/objects/instagram-related-product-tags';
import './../src/objects/instagram-shopping-merchant-review-message';
import './../src/objects/instagram-user';
import './../src/objects/instagram-video-metadata';
import './../src/objects/instant-article-insights-query-result';
import './../src/objects/ios-app-link';
import './../src/objects/job-opening';
import './../src/objects/key-value';
import './../src/objects/keyword-delivery-report';
import './../src/objects/lead';
import './../src/objects/lead-gen-appointment-booking-info';
import './../src/objects/lead-gen-appointment-slots-by-day';
import './../src/objects/lead-gen-appointment-time-slot';
import './../src/objects/lead-gen-conditional-questions-group-choices';
import './../src/objects/lead-gen-conditional-questions-group-questions';
import './../src/objects/lead-gen-context-card';
import './../src/objects/lead-gen-custom-disclaimer';
import './../src/objects/lead-gen-custom-disclaimer-body';
import './../src/objects/lead-gen-data-draft';
import './../src/objects/lead-gen-direct-crm-integration-config';
import './../src/objects/lead-gen-draft-question';
import './../src/objects/lead-gen-form-preview-details';
import './../src/objects/lead-gen-legal-content';
import './../src/objects/lead-gen-legal-content-checkbox';
import './../src/objects/lead-gen-post-submission-check-result';
import './../src/objects/lead-gen-privacy-policy';
import './../src/objects/lead-gen-question';
import './../src/objects/lead-gen-question-option';
import './../src/objects/lead-gen-thank-you-page';
import './../src/objects/lead-gen-thank-you-page-gated-file';
import './../src/objects/lead-gen-thank-you-page-gated-promo';
import './../src/objects/lead-gen-url-entity-at-ranges';
import './../src/objects/leadgen-form';
import './../src/objects/life-event';
import './../src/objects/link';
import './../src/objects/linked-instagram-account-data';
import './../src/objects/live-video';
import './../src/objects/live-video-ad-break-config';
import './../src/objects/live-video-error';
import './../src/objects/live-video-input-stream';
import './../src/objects/live-video-recommended-encoder-settings';
import './../src/objects/live-video-targeting';
import './../src/objects/local-service-business';
import './../src/objects/location';
import './../src/objects/lookalike-spec';
import './../src/objects/loom-config';
import './../src/objects/mc-experience-config-for-api';
import './../src/objects/mix-insights-result';
import './../src/objects/mailing-address';
import './../src/objects/managed-partner-business';
import './../src/objects/managed-partner-extended-credit';
import './../src/objects/marketing-message-targeting';
import './../src/objects/mcom-invoice-bank-account';
import './../src/objects/mcom-invoice-details';
import './../src/objects/mcom-invoice-lists';
import './../src/objects/mcom-invoice-status';
import './../src/objects/mcom-onboarding-status';
import './../src/objects/mcom-payouts';
import './../src/objects/measurement-report';
import './../src/objects/media-copyright-attribution';
import './../src/objects/media-copyright-update-record';
import './../src/objects/media-fingerprint';
import './../src/objects/media-title';
import './../src/objects/merchant-compliance';
import './../src/objects/merchant-report';
import './../src/objects/message-delivery-estimate';
import './../src/objects/messaging-apps-info';
import './../src/objects/messaging-feature-review';
import './../src/objects/messaging-feature-status';
import './../src/objects/messenger-ads-partial-automated-step-list';
import './../src/objects/messenger-business-template';
import './../src/objects/messenger-call-settings';
import './../src/objects/messenger-destination-page-welcome-message';
import './../src/objects/messenger-profile';
import './../src/objects/minimum-budget';
import './../src/objects/music-video-copyright';
import './../src/objects/music-work-copyright';
import './../src/objects/negative-keyword-list';
import './../src/objects/null-node';
import './../src/objects/offline-conversion-data-set';
import './../src/objects/offline-conversion-data-set-activities';
import './../src/objects/offline-conversion-data-set-optimization-status';
import './../src/objects/offline-conversion-data-set-permissions';
import './../src/objects/offline-conversion-data-set-upload';
import './../src/objects/offline-conversion-data-set-usage';
import './../src/objects/offline-product-item';
import './../src/objects/offline-terms-of-service';
import './../src/objects/offsite-pixel';
import './../src/objects/offsite-signal-container-business-object';
import './../src/objects/omega-customer-trx';
import './../src/objects/open-bridge-configuration';
import './../src/objects/open-graph-context';
import './../src/objects/order-id-attributions';
import './../src/objects/organization';
import './../src/objects/outcome-prediction-point';
import './../src/objects/override-details';
import './../src/objects/owned-domain';
import './../src/objects/p2m-invoice-payments';
import './../src/objects/page';
import './../src/objects/page-about-story-composed-block';
import './../src/objects/page-about-story-composed-block-entity-ranges';
import './../src/objects/page-about-story-composed-block-inline-style';
import './../src/objects/page-app-with-leads-access';
import './../src/objects/page-broadcast';
import './../src/objects/page-cts-topic';
import './../src/objects/page-ctx-budget-similar-advertiser-budget-recommendation';
import './../src/objects/page-ctx-default-greeting-text';
import './../src/objects/page-ctx-messaging-feature-limit';
import './../src/objects/page-call-to-action';
import './../src/objects/page-category';
import './../src/objects/page-change-proposal';
import './../src/objects/page-crms-with-leads-access';
import './../src/objects/page-direct-integration-crm-with-leads-access';
import './../src/objects/page-game-bot-quota-information';
import './../src/objects/page-get-started-nullstate';
import './../src/objects/page-insights-async-export-run';
import './../src/objects/page-leads-access-config';
import './../src/objects/page-locations-breakdown';
import './../src/objects/page-message-responsiveness-metrics';
import './../src/objects/page-parking';
import './../src/objects/page-partner-with-leads-access';
import './../src/objects/page-payment-options';
import './../src/objects/page-post';
import './../src/objects/page-post-experiment';
import './../src/objects/page-publisher';
import './../src/objects/page-restaurant-services';
import './../src/objects/page-restaurant-specialties';
import './../src/objects/page-settings';
import './../src/objects/page-start-info';
import './../src/objects/page-thread-owner';
import './../src/objects/page-upcoming-change';
import './../src/objects/page-user-message-thread-label';
import './../src/objects/page-user-permissions';
import './../src/objects/page-user-with-leads-access';
import './../src/objects/parent-catalog-report';
import './../src/objects/partner-account-linking';
import './../src/objects/partner-category';
import './../src/objects/partner-integration-linked';
import './../src/objects/partner-study';
import './../src/objects/partnership-ad-content-search-media';
import './../src/objects/partnership-ads-identity';
import './../src/objects/payment-engine-payment';
import './../src/objects/payment-pricepoints';
import './../src/objects/payment-request-details';
import './../src/objects/payment-subscription';
import './../src/objects/permission';
import './../src/objects/persona';
import './../src/objects/personal-ads-persona';
import './../src/objects/photo';
import './../src/objects/photo-metadata';
import './../src/objects/place';
import './../src/objects/place-tag';
import './../src/objects/place-topic';
import './../src/objects/placement';
import './../src/objects/platform-image-source';
import './../src/objects/platform-session-key';
import './../src/objects/playable-content';
import './../src/objects/post';
import './../src/objects/preapproval-review';
import './../src/objects/premium-music-video';
import './../src/objects/privacy';
import './../src/objects/privacy-option';
import './../src/objects/private-computation-environment';
import './../src/objects/private-lift-study-instance';
import './../src/objects/product-catalog';
import './../src/objects/product-catalog-category';
import './../src/objects/product-catalog-data-source';
import './../src/objects/product-catalog-diagnostic-group';
import './../src/objects/product-catalog-facets';
import './../src/objects/product-catalog-hotel-rooms-batch';
import './../src/objects/product-catalog-image-settings';
import './../src/objects/product-catalog-image-settings-internal';
import './../src/objects/product-catalog-image-settings-operation';
import './../src/objects/product-catalog-localization-settings';
import './../src/objects/product-catalog-pricing-variables-batch';
import './../src/objects/product-catalog-product-sets-batch';
import './../src/objects/product-catalog-user-actions';
import './../src/objects/product-catalog-user-permissions';
import './../src/objects/product-catalog-user-tasks';
import './../src/objects/product-da-event-samples-batch';
import './../src/objects/product-delivery-preference';
import './../src/objects/product-event-stat';
import './../src/objects/product-feed';
import './../src/objects/product-feed-rule';
import './../src/objects/product-feed-rule-preview-sample';
import './../src/objects/product-feed-rule-suggestion';
import './../src/objects/product-feed-schedule';
import './../src/objects/product-feed-upload';
import './../src/objects/product-feed-upload-error';
import './../src/objects/product-feed-upload-error-report';
import './../src/objects/product-feed-upload-error-sample';
import './../src/objects/product-feed-upload-progress';
import './../src/objects/product-group';
import './../src/objects/product-image';
import './../src/objects/product-item';
import './../src/objects/product-item-commerce-insights';
import './../src/objects/product-item-error';
import './../src/objects/product-item-importer-address';
import './../src/objects/product-item-insights';
import './../src/objects/product-item-invalidation-error';
import './../src/objects/product-item-landing-page-data';
import './../src/objects/product-item-local-info';
import './../src/objects/product-item-local-info-lat-long-shape';
import './../src/objects/product-item-offer';
import './../src/objects/product-item-shipping';
import './../src/objects/product-item-subscription-info';
import './../src/objects/product-item-unit-price';
import './../src/objects/product-set';
import './../src/objects/product-set-metadata';
import './../src/objects/product-set-taxon-category';
import './../src/objects/product-set-usage';
import './../src/objects/product-variant';
import './../src/objects/product-visual-variant';
import './../src/objects/profile';
import './../src/objects/profile-picture-source';
import './../src/objects/publisher-block-list';
import './../src/objects/publisher-delivery-report';
import './../src/objects/publisher-white-list';
import './../src/objects/rtb-dynamic-post';
import './../src/objects/raw-custom-audience';
import './../src/objects/reach-frequency-activity';
import './../src/objects/reach-frequency-ad-format';
import './../src/objects/reach-frequency-curve-lower-confidence-range';
import './../src/objects/reach-frequency-curve-upper-confidence-range';
import './../src/objects/reach-frequency-day-part';
import './../src/objects/reach-frequency-estimates-curve';
import './../src/objects/reach-frequency-estimates-placement-breakdown';
import './../src/objects/reach-frequency-prediction';
import './../src/objects/reach-frequency-spec';
import './../src/objects/recommendation';
import './../src/objects/recommended-ig-media';
import './../src/objects/recommended-page-post';
import './../src/objects/regional-regulation-identities';
import './../src/objects/reporting-audience';
import './../src/objects/research-poll-study';
import './../src/objects/reseller-guidance';
import './../src/objects/rev-share-policy';
import './../src/objects/rich-media-element';
import './../src/objects/rights-manager-data-export';
import './../src/objects/rights-manager-insights';
import './../src/objects/robot';
import './../src/objects/sales-rights-inventory-management';
import './../src/objects/saved-audience';
import './../src/objects/saved-message-response';
import './../src/objects/scheduled-post';
import './../src/objects/scim-company-user-phone-number';
import './../src/objects/security-settings';
import './../src/objects/shadow-ig-hashtag';
import './../src/objects/shadow-ig-media-boosted-insights-result';
import './../src/objects/shadow-ig-media-builder';
import './../src/objects/shadow-ig-media-collaborators';
import './../src/objects/shadow-ig-media-product-tags';
import './../src/objects/shadow-ig-user-catalog-product-search';
import './../src/objects/shadow-ig-user-catalog-product-variant';
import './../src/objects/shadow-ig-user-partnership-ads-media-errors';
import './../src/objects/shop';
import './../src/objects/signals-iwl-extractor';
import './../src/objects/single-owner-additional-profile';
import './../src/objects/site-link';
import './../src/objects/sliced-event-source-group';
import './../src/objects/smart-pixel-insights';
import './../src/objects/social-wifi-site';
import './../src/objects/split-test-config';
import './../src/objects/split-test-winner';
import './../src/objects/status';
import './../src/objects/store-catalog-settings';
import './../src/objects/stories';
import './../src/objects/stream-filter';
import './../src/objects/system-user';
import './../src/objects/tab';
import './../src/objects/taggable-subject';
import './../src/objects/targeting';
import './../src/objects/targeting-automation';
import './../src/objects/targeting-dynamic-rule';
import './../src/objects/targeting-geo-location';
import './../src/objects/targeting-geo-location-city';
import './../src/objects/targeting-geo-location-custom-location';
import './../src/objects/targeting-geo-location-electoral-district';
import './../src/objects/targeting-geo-location-geo-entities';
import './../src/objects/targeting-geo-location-location-cluster';
import './../src/objects/targeting-geo-location-location-expansion';
import './../src/objects/targeting-geo-location-market';
import './../src/objects/targeting-geo-location-place';
import './../src/objects/targeting-geo-location-political-district';
import './../src/objects/targeting-geo-location-region';
import './../src/objects/targeting-geo-location-zip';
import './../src/objects/targeting-marketing-message-channels';
import './../src/objects/targeting-product-audience-spec';
import './../src/objects/targeting-product-audience-sub-spec';
import './../src/objects/targeting-prospecting-audience';
import './../src/objects/targeting-relaxation';
import './../src/objects/targeting-sentence-line';
import './../src/objects/text-with-entities';
import './../src/objects/third-party-measurement-report-dataset';
import './../src/objects/third-party-partner-lift-request';
import './../src/objects/third-party-partner-panel-request';
import './../src/objects/third-party-partner-panel-scheduled';
import './../src/objects/third-party-partner-viewability-request';
import './../src/objects/time-suggestion';
import './../src/objects/timezone-offset';
import './../src/objects/tracking-and-conversion-with-defaults';
import './../src/objects/transactable-item';
import './../src/objects/transaction';
import './../src/objects/url';
import './../src/objects/unified-thread';
import './../src/objects/unique-ad-creative';
import './../src/objects/user';
import './../src/objects/user-available-catalogs';
import './../src/objects/user-context';
import './../src/objects/user-cover-photo';
import './../src/objects/user-device';
import './../src/objects/user-id-for-app';
import './../src/objects/user-id-for-page';
import './../src/objects/user-lead-gen-disclaimer-response';
import './../src/objects/user-lead-gen-field-data';
import './../src/objects/user-mobile-config';
import './../src/objects/user-notification-seen-state-data';
import './../src/objects/user-page-one-time-opt-in-token-settings';
import './../src/objects/user-payment-methods-info';
import './../src/objects/user-payment-mobile-pricepoints';
import './../src/objects/user-payment-modules-options';
import './../src/objects/value-based-eligible-source';
import './../src/objects/vehicle';
import './../src/objects/vehicle-offer';
import './../src/objects/video-copyright';
import './../src/objects/video-copyright-check-status';
import './../src/objects/video-copyright-condition-group';
import './../src/objects/video-copyright-geo-gate';
import './../src/objects/video-copyright-match';
import './../src/objects/video-copyright-rule';
import './../src/objects/video-copyright-segment';
import './../src/objects/video-group';
import './../src/objects/video-list';
import './../src/objects/video-metrics-report';
import './../src/objects/video-poll';
import './../src/objects/video-stats';
import './../src/objects/video-status';
import './../src/objects/video-status-error';
import './../src/objects/video-status-processing-phase';
import './../src/objects/video-status-publishing-phase';
import './../src/objects/video-status-uploading-phase';
import './../src/objects/video-text-question';
import './../src/objects/video-thumbnail';
import './../src/objects/video-upload-limits';
import './../src/objects/voip-info';
import './../src/objects/wit-user';
import './../src/objects/wearable-device-public-key';
import './../src/objects/web-app-link';
import './../src/objects/web-publisher';
import './../src/objects/website-creative-asset-source';
import './../src/objects/website-creative-asset-suggestions';
import './../src/objects/whats-app-business-account';
import './../src/objects/whats-app-business-health-status';
import './../src/objects/whats-app-business-health-status-for-message-send';
import './../src/objects/whats-app-business-partner-client-verification-submission';
import './../src/objects/whats-app-business-pre-verified-phone-number';
import './../src/objects/whats-app-business-profile';
import './../src/objects/whats-app-payment-capabilities';
import './../src/objects/whatsapp-subscribed-apps-info';
import './../src/objects/whitehat-fbdl-run';
import './../src/objects/wifi-information';
import './../src/objects/windows-app-link';
import './../src/objects/windows-phone-app-link';
import './../src/objects/with-asset-3d';
import './../src/objects/woodhenge-purchased-payg-receipt';
import './../src/objects/woodhenge-supporter';
import './../src/objects/work-access-code';
import './../src/objects/work-experience';
import './../src/objects/work-skill';
import './../src/objects/work-user-badges';
import './../src/objects/work-user-frontline';
